import { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { PageContainer } from '../../../components/PageContainer';
import { NotFound } from '../../../components/NotFound';
import { Card, Dropdown, Form } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';
import { Modal } from '../../../components/Modal';
import StatusBadge from '../../../components/StatusBadge';
import { ColorForm } from './color-form';
import { ColorModel, fetchColorList } from '../../../model/color.model';
import { Actions } from '../../../components/Actions';

export default function ColorList() {
  const [list, setList] = useState<Array<ColorModel>>([]);
  const [filterList, setFilterList] = useState<Array<ColorModel>>([]);
  const { authInfo } = useAuth();
  const { isLoading, showLoader, hideLoader, confirm } = useUtility();
  const [selectedColor, setSelectedColor] = useState<ColorModel>();


  function handleEdit(color: ColorModel) {
    setSelectedColor(color);
  }

  async function handleDelete(color: ColorModel) {
    try {
      const isConfirmed = await confirm(`Are you want to delete the Color: ${color.color_name}`);
      if (isConfirmed && color.id) {
        // await deleteColor(item.id, authInfo);
        setList(prev => prev.filter(p => p.id !== color.id));
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        const res = await fetchColorList(authInfo);
        setList(res);
        setFilterList(res);
      } catch (err) {
        console.error(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo]);
  return (
    <>
      <PageContainer
        title="Color Master"
        addButtonHandler={() => setSelectedColor({} as ColorModel)}
        body={
          !isLoading && list.length === 0 ? <NotFound /> : <>
            <Form.Group className="mb-3" controlId="colorSearch">
              <Form.Control
                type="text"
                placeholder="Search by color name..."
                onChange={(e) => {
                  const keyword = e.target.value.toLowerCase();
                  setFilterList(
                    list.filter(color => color.color_name.toLowerCase().includes(keyword))
                  );
                }}
              />
            </Form.Group>
            {filterList.map((color, index) => (
              <Card key={`card-${index}`} className="mb-3">
                <Card.Body>
                  <Card.Title className="d-flex justify-content-between align-items-center">
                    <span>{color.color_name}</span>
                    <Actions index={index}>
                      <Dropdown.Item onClick={() => handleEdit(color)}>Edit</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(color)}>Delete</Dropdown.Item>
                    </Actions>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    <StatusBadge value={color.publish} />
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            ))}
          </>
        }
      />
      <Modal
        title={selectedColor?.color_name ?? "Color Master"}
        show={!!selectedColor}
        handleClose={() => setSelectedColor(undefined)}
        fullscreen
      >
        <ColorForm
          color={selectedColor}
          onSuccess={(color) => {
            setList(prev => {
              const exists = prev.findIndex(p => p.id === color.id);
              if (exists !== -1) {
                const updated = [...prev];
                updated[exists] = color;
                return updated;
              }
              return [...prev, color];
            });
            setSelectedColor(undefined);
          }}
        />
      </Modal>
    </>
  );
};